import type { AuthUser } from "../context/AuthContext";
import { isAuthenticatedFounder, isAuthenticatedPublisher } from "./authAccess";

export const FOUNDER_LOGIN_PATH = "/founder/log-in";

export type FounderRouteGuardDecision =
  | { action: "loading" }
  | { action: "allow" }
  | { action: "redirect"; to: string; state?: { from: string } };

export function evaluateFounderProtectedRouteGuard(
  input: {
    isLoading: boolean;
    user: AuthUser | null;
  },
  fromPath: string,
): FounderRouteGuardDecision {
  if (input.isLoading) {
    return { action: "loading" };
  }

  if (!input.user) {
    return {
      action: "redirect",
      to: FOUNDER_LOGIN_PATH,
      state: { from: fromPath },
    };
  }

  if (!isAuthenticatedFounder(input.user)) {
    return { action: "redirect", to: "/" };
  }

  return { action: "allow" };
}

export function evaluateFounderGuestRouteGuard(input: {
  isLoading: boolean;
  user: AuthUser | null;
}): FounderRouteGuardDecision {
  if (input.isLoading) {
    return { action: "loading" };
  }

  if (isAuthenticatedFounder(input.user)) {
    return { action: "redirect", to: "/founder/hub/overview" };
  }

  if (isAuthenticatedPublisher(input.user)) {
    return { action: "redirect", to: "/" };
  }

  return { action: "allow" };
}
